<template>
	<div
		class="c-global-search-autosuggestions__box"
		v-if="globalAutoSuggestSearchResults.length || noAutocompleteItems || isLoading"
		 ref="autosuggestionsDropDown">
		<div v-show="globalAutoSuggestSearchResults.length || noAutocompleteItems" class="c-global-search-autosuggestions__result-wrapper">
			<ul
				v-show="globalAutoSuggestSearchResults.length"
				class="c-global-search-autosuggestions__wrapper c-global-search-autosuggestions__results"
				id="autosuggest-list"
				role="listbox"
				aria-live="polite">
				<global-search-autoSuggest-item
												v-for="card in globalAutoSuggestSearchResults"
												:key="card.id"
												:card="card"
												:ref="'card-' + card.id" />
			</ul>
			<global-search-did-you-mean v-if="noAutocompleteItems && didYouMeanItems?.length > 0"
				@didYouMeanSearch="didYouMeanSearch"
				:headline="noSearchResultsHeadline"
				:text="didYouMeanText"
				:items="didYouMeanItems"
			>
			</global-search-did-you-mean>
			<global-search-empty
				v-else-if="noAutocompleteItems"
				:headline="noSearchResultsHeadline"
				:text="noSearchResultsText"
			>
			</global-search-empty>
		</div>
		<div class="c-global-search-autosuggestions__loading" v-show="isLoading">
			<inline-spinner class="c-global-search-autosuggestions__spinner" size="lg"></inline-spinner>
		</div>
	</div>
</template>

<script>
	import globalSearchAutoSuggestItem from 'shared/components/globalSearch/globalSearchAutosuggestItem.vue';
	import globalSearchDidYouMean from 'shared/components/globalSearch/globalSearchDidYouMean.vue';
	import globalSearchEmpty from 'shared/components/globalSearch/globalSearchEmpty.vue';
	import inlineSpinner from 'shared/components/inlineSpinner.vue';
	import { mapGetters, mapActions } from 'vuex';

	export default {
		name: 'global-search-autoSuggest-dropDown-list',
		components: {
			globalSearchAutoSuggestItem,
			globalSearchDidYouMean,
			globalSearchEmpty,
			inlineSpinner,
		},
		computed: {
			...mapGetters({
				didYouMeanItems: 'getAutosuggestDidYouMeanItems',
				globalAutoSuggestSearchResults: 'getGlobalAutoSuggestSearchResults',
				noAutocompleteItems: 'getNoAutocompleteItems',
				selectedSuggestionIndex: 'getSelectedSuggestionIndex'
			}),
		},
		methods: {
			...mapActions([
				'autoSuggestGlobalSearch',
				'cancelAutosuggestionSearch',
			]),
			didYouMeanSearch(item) {
				this.$emit('didYouMeanSearch', item);
			},
			focusControl(id) {
				// If the dropdown is visible
				if (this.globalAutoSuggestSearchResults?.length || this.noAutocompleteItems) {
					this.$nextTick(() => {
						if (id) {
							this.$refs[`card-${id}`][0].focusElement();
						}
					});
				}
			},
		},
		props: {
			isLoading: Boolean,
			noSearchResultsHeadline: String,
			noSearchResultsText: String,
			didYouMeanText: String,
		},
		watch: {
			selectedSuggestionIndex(newIndex) {
				if ( newIndex >= 0 ) {
					this.focusControl(this.globalAutoSuggestSearchResults[newIndex].id)
				}
			}
		}
	};
</script>
